module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"audit_widget_label":"Audits","audit_widget_myaudits":"Zu erledigen","audit_widget_allaudits":"Verantwortlich","audit_widget_auditdate":"Audit-Datum: "},"en":{"audit_widget_label":"Audits","audit_widget_myaudits":"Todos","audit_widget_allaudits":"Verantwortlich","audit_widget_auditdate":"Audit-Date: "}}')
  delete Component.options._Ctor
}
